<template>
  <div
    class="comment"
    @click="toInfo"
    v-if="commentData"
  >
    <div
      :class="{ border: border }"
      style="display: flex;width: 100%;"
    >
      <a-avatar
        style="flex-shrink:0"
        :size="56"
        :src="commentData.userIcon"
      />
      <div class="comment_info">
        <h3>
          <span class="fs-16 font-bold">{{ commentData.userName }}</span>
          <span
            class="font-12 ml-2"
            style="color: rgba(0,0,0,0.4);"
          >{{ ctime(commentData.ctime) }}</span>
        </h3>
        <p class="font-14 mt-2 mb-3">
          {{ commentData.content }}
        </p>
        <!-- images -->
        <div
          class="images"
          v-if="imgs.length"
          @click.prevent.stop
        >
          <!-- <img @click="preview" v-for="src in imgs" :key="src" :src="src" /> -->
          <template v-if="!whole">
            <img
              @click="preview"
              v-for="src in imgs.slice(0, 3)"
              :key="src"
              :src="src"
            />
            <div
              class="add"
              v-if="imgs.length > 3"
            >{{ imgs.length }}图</div>
          </template>
          <template v-else>
            <img
              @click="preview"
              v-for="src in imgs"
              :key="src"
              :src="src"
            />
          </template>
        </div>
        <div
          class="lately_comment"
          v-if="commentData.replyContent"
        >
          <p class="text-cut-2 font-14">
            <span style="align-self: start;">回复</span>
            <span style="align-self: start;margin-left: 5px; color: #181D21;font-size: 16px;font-weight: bold;">{{ commentData.replyUserName }}：</span>
            <span class="">{{ commentData.replyContent }}</span>
          </p>
        </div>
        <div
          class="more"
          v-if="more"
        >
          <slot name="more">
            <div
              v-if="opers.length"
              class="opers"
              :class="{ 'ml-auto': !info }"
              @click.prevent.stop
            >
            <p
                class="oper"
                @click.stop="delVisible = true"
                v-if="infoOpers.includes('del') && deleteShow"
              >
                <svg-icon iconClass="delete"></svg-icon>
                <span class="font-12 ml-1">删除</span>
              </p>
              <p
                class="oper"
                v-if="opers.includes('adopt')"
                @click="$emit('onAdopt', commentData)"
              >
                <!-- <p class="oper" @click="$emit('onAdopt', commentData)"> -->
                <svg-icon iconClass="adopted-icon"></svg-icon>
                <!-- <span class="font-12 ml-1">采纳回答</span> -->
              </p>
              <p
                class="oper"
                v-if="opers.includes('like')"
                @click="$emit('onLike', commentData)"
              >
                <svg-icon :iconClass="commentData.state == '1' ? 'like_active' : 'like_default'"></svg-icon>
                <span class="font-12 ml-1">{{ commentData.zanNum || '点赞' }}</span>
              </p>
              <p
                class="oper"
                v-if="opers.includes('tread')"
                @click="$emit('onTread', commentData)"
              >
                <svg-icon :iconClass="commentData.state == '2' ? 'tread_active' : 'tread_default'"></svg-icon>
                <span class="font-12 ml-1">{{ commentData.disNum || '点踩' }}</span>
              </p>
              <p
                class="oper"
                v-if="opers.includes('reply')"
                @click="isComment = !isComment"
              >
                <svg-icon iconClass="comment_default"></svg-icon>
                <span class="font-12 ml-1">回复</span>
              </p>
            </div>

            <div
              v-if="info"
              class="info"
            >
              <p
                class="oper"
                @click.stop="delVisible = true"
                v-if="infoOpers.includes('del') && deleteShow"
              >
                <svg-icon iconClass="delete"></svg-icon>
                <span class="font-12 ml-1">删除</span>
              </p>
              <p v-if="infoOpers.includes('watch')">
                <svg-icon iconClass="browse"></svg-icon>
                <span class="font-12 ml-1">{{ commentData.watchNum || 0 }}</span>
              </p>
              <p v-if="infoOpers.includes('like')">
                <svg-icon :iconClass="commentData.isZan ? 'like_active' : 'like_default'"></svg-icon>
                <span class="font-12 ml-1">{{ commentData.zanNum || 0 }}</span>
              </p>
              <p v-if="infoOpers.includes('tread')">
                <svg-icon :iconClass="commentData.disNum ? 'tread_active' : 'tread_default'"></svg-icon>
                <span class="font-12 ml-1">{{ commentData.disNum || 0 }}</span>
              </p>
              <p v-if="infoOpers.includes('reply')">
                <svg-icon iconClass="comment_default"></svg-icon>
                <span class="font-12 ml-1">{{ commentData.commentNum || '回复' }}</span>
              </p>
            </div>
          </slot>
        </div>
        <div
          style="margin-left: -64px"
          class="flex mt-3"
          v-show="isComment"
        >
          <a-avatar
            :size="48"
            :src="photo"
          />
          <div class="ml-5 flex-1">
            <a-input
              v-model="content"
              :placeholder="'回复' + commentData.userName"
            ></a-input>
            <a-button
              type="primary"
              class="comment_btn"
              @click="onReply"
            >回复</a-button>
          </div>
        </div>
      </div>
    </div>
    <svg-icon
      class="adopt"
      iconClass="adopt"
      v-if="commentData.adopt === 'Y'"
    ></svg-icon>
    <z-modal
      :width="335"
      :button="false"
      title="提示"
      :visible.sync="delVisible"
    >
      <div class="text-center font-12 text-black">删除后无法恢复，确定删除吗？</div>
      <div class="d-flex justify-between mt-5">
        <a-button
          class="btn mr-4 flex-1"
          @click="delVisible = false"
        >取消</a-button>
        <a-button
          class="btn flex-1 del"
          @click="confirmDelete"
        >删除</a-button>
      </div>
    </z-modal>
  </div>
</template>
<script>
import zModal from '@/components/ZModal'
// import dianzan from '@/assets/icons/点赞@2x.png'
// import pinglun from '@/assets/icons/评论@2x.png'
// import yuedu from '@/assets/icons/阅读@2x.png'
// import dianzanDefault from '@/assets/icons/dianzan_default.png'
// import dianzanSuccess from '@/assets/icons/dianzan_success.png'
// import treadDefault from '@/assets/icons/tread_default.png'
// import treadActive from '@/assets/icons/tread_active.png'
// import iconDelete from '@/assets/icons/delete.png'
// import iconComment from '@/assets/icons/comment.png'
// import adopt from '@/assets/icons/adopt.png'
import { transformUrl } from '@/utils/util'
import Vue from 'vue'
import moment from 'moment'
export default {
  name: 'Comment',
  props: {
    commentData: {
      type: Object,
      default: () => null
    },
    // 操作数组： ['like', 'tread', 'reply', 'adopt', 'del']
    opers: {
      type: Array,
      default: () => []
    },
    // 底部操作项和数据展示项
    more: {
      type: Boolean,
      default: true
    },
    // 底部的数据展示
    info: {
      type: Boolean,
      default: true
    },
    infoOpers: {
      type: Array,
      default: () => ['like', 'watch', 'reply', 'tread', 'del']
    },
    // 是否显示边框
    border: {
      type: Boolean,
      default: true
    },
    themeUserId: {
      type: String,
      default: ''
    },
    whole: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: false,
      content: '',
      loading: false,
      delVisible: false,
      isComment: false
    }
  },
  computed: {
    photo () {
      const data = this.$store.getters.getUserData('headImgUrl')
      return data.headImgUrl
    },
    ctime () {
      return time => {
        return moment(time).fromNow()
      }
    },
    imgs () {
      let photos = this.commentData.photos
      if (!photos || photos.includes('[]')) return []
      let arr = []
      if (photos.includes('[')) {
        const imgs = JSON.parse(photos)
        photos = imgs
          .reduce((v1, v2) => {
            v1.push(v2.url.substr(5))
            return v1
          }, [])
          .join(',')
      }
      arr = photos.split(',').map(item => transformUrl(item))
      return arr
    },
    deleteShow () {
      const { id: userId } = this.$store.getters.getUserData('id')
      const commentUserId = this.commentData.userId
      if (!userId || !commentUserId) {
        return false
      }
      if (userId === commentUserId) {
        return true
      }
      return false
    }
  },
  watch: {
    isComment (val) {
      !val && (this.content = '')
    }
  },
  components: {
    zModal
  },
  methods: {
    preview () {
      this.$viewerApi({
        images: this.imgs
      })
    },
    confirmDelete () {
      this.$emit('onDelete', this.commentData)
    },
    onReply () {
      if (!this.content) {
        this.$message.warning('你还未输入回复内容')
        return
      }
      this.$emit('onReply', this.formatParams(this.content, this.commentData))
      // this.remove()
    },
    remove () {
      this.content = ''
      this.isComment = false
    },
    formatParams (
      content,
      { role, themeId, id: replyCommentId, userId: replyUserId, userName: replyUserName, content: replyContent }
    ) {
      return {
        content,
        themeId,
        replyCommentId,
        replyUserId,
        replyUserName,
        replyContent,
        role
      }
    },
    toInfo () {
      if (this.$route.name === 'qadetails') return
      const id = this.commentData.themeId || this.commentData.id
      this.$router.push({ name: 'qadetails', query: { id, ocode: Vue.ls.get('code') } })
    },
    close () {
      this.visible = false
      this.content = ''
    }
  }
}
</script>
<style lang="less" scoped>
.comment {
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding-top: 24px;
  // padding: 24px 16px 0;
  font-size: 16px;
  color: #181d21;
  .ml-auto {
    margin-left: auto;
  }
  .font-12 {
    color: rgba(0, 0, 0, 0.4);
  }
  .adopt {
    position: absolute;
    top: 0;
    right: 25%;
    width: 60px;
    height: 60px;
  }
  .comment_info {
    flex: 1;
    padding-bottom: 18px;
    margin-left: 18px;
    position: relative;
    overflow: hidden;
    h3 {
      display: flex;
      align-items: center;
    }
    .date {
      display: inline-block;
      margin: 8px 0;
      font-size: 14px;
      color: #5e668d;
    }
    .lately_comment {
      width: 100%;
      padding: 14px;
      // min-height: 45px;
      // padding-left: 24px;
      // height: 45px;
      // padding: 12px 0 12px 24px;
      margin-top: 16px;
      line-height: 24px;
      background: #f9fafc;
      border-radius: 5px;
      color: #5e668d;
      margin-bottom: 10px;
      // overflow : hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // p {
      //   min-height: 45px;
      // }
    }
    .images {
      width: 800px;
      max-width: 800px;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      margin-top: 16px;
      img {
        width: 240px;
        height: 152px;
        margin-right: 16px;
        margin-bottom: 16px;
        object-fit: cover;
        border-radius: 4px;
      }
      // .img {
      //   width: 112px;
      //   height: 112px;
      // }
      .add {
        position: absolute;
        bottom: 16px;
        left: 710px;
        width: 42px;
        text-align: center;
        color: #fff;
        line-height: 22px;
        font-size: 12px;
        background-color: rgba(0, 0, 0, 0.62);
        border-radius: 4px 0px 4px 0px;
      }
    }
    .more {
      width: 100%;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      // margin-top: 18px;
      .opers {
        display: flex;
        align-items: center;
        .oper {
          display: flex;
          align-items: center;
          margin-right: 12px;
          cursor: pointer;
          img {
            width: 15px;
            height: 15px;
            margin-bottom: 2px;
            margin-right: 4px;
          }
          span {
            color: rgba(0, 0, 0, 0.4);
            line-height: 14px;
          }
        }
      }
      // .delete {
      //   margin-right: 12px;
      //   color: #1564ff;
      //   cursor: pointer;
      // }
      .info {
        display: flex;
        margin-left: auto;
        font-size: 16px;
        cursor: pointer;
        p {
          display: flex;
          align-items: center;
          margin-left: 20px;
          // img {
          //   margin-right: 4px;
          //   cursor: pointer;
          // }
        }
      }
    }
  }
  .ant-input {
    background: #fbfbfb;
    border-radius: 4px;
    border: 1px solid #dcdcdc;
  }
  .border {
    border-bottom: 1px solid #e7e7e7;
  }
}
.del_context {
  position: relative;
  bottom: 20px;
  font-size: 18px;
  font-weight: bold;
}
.btn {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  font-size: 14px;
  // font-weight: bold;
  color: #4b7dfd;
  border: 1px solid #4b7dfd;
}
.comment_btn {
  width: 72px;
  height: 24px;
  float: right;
  margin-top: 8px;
  line-height: 24px;
  font-size: 12px;
  background: #4b7dfd;
  border-radius: 3px;
}
.del {
  color: #fff;
  background-color: #4b7dfd;
}
</style>
